<template>
  <div class="article-detail-skeleton">
    <!-- Breadcrumbs skeleton -->
    <div
      class="loading-effect breadcrumbs w-1/2 md:w-2/12 h-[20px] mt-4 hidden md:block"
    ></div>

    <!-- Main content area with responsive layout -->
    <div class="grid grid-cols-1 lg:grid-cols-3 gap-8 mt-6">
      <!-- Main content column -->
      <div class="lg:col-span-2">
        <div class="w-full">
          <!-- Article header skeleton -->
          <div class="article-header-skeleton">
            <!-- Header image skeleton -->
            <div
              class="loading-effect w-full h-[260px] md:h-[480px] rounded-lg mb-4"
            ></div>

            <!-- Title skeleton -->
            <div
              class="loading-effect title w-3/4 h-[32px] md:h-[40px] mb-4"
            ></div>

            <!-- Author and date skeleton -->
            <div class="flex items-center gap-4 mb-4">
              <div class="loading-effect w-24 h-4"></div>
              <div class="loading-effect w-32 h-4"></div>
            </div>

            <hr class="my-3 border-gray-600" />
          </div>

          <!-- Category skeleton (mobile only) -->
          <div class="md:hidden">
            <div class="loading-effect w-1/2 h-[28px] mb-2"></div>
            <div class="loading-effect w-full h-[20px] mb-4"></div>
            <hr class="my-3 border-gray-600" />
          </div>

          <!-- Summary block skeleton -->
          <div class="summary-block-skeleton bg-[#f0f6f6] p-5 rounded-xl mb-8">
            <div class="loading-effect w-1/3 h-[24px] mb-4"></div>
            <div class="loading-effect w-full h-[16px] mb-2"></div>
            <div class="loading-effect w-5/6 h-[16px] mb-2"></div>
            <div class="loading-effect w-4/6 h-[16px]"></div>
          </div>

          <!-- Article content skeleton -->
          <div class="article-content-skeleton">
            <div class="loading-effect w-full h-[16px] mb-3"></div>
            <div class="loading-effect w-full h-[16px] mb-3"></div>
            <div class="loading-effect w-5/6 h-[16px] mb-3"></div>
            <div class="loading-effect w-full h-[16px] mb-3"></div>
            <div class="loading-effect w-4/6 h-[16px] mb-3"></div>
            <div class="loading-effect w-full h-[16px] mb-3"></div>
            <div class="loading-effect w-3/4 h-[16px] mb-3"></div>
            <div class="loading-effect w-full h-[16px] mb-3"></div>
            <div class="loading-effect w-5/6 h-[16px] mb-3"></div>
            <div class="loading-effect w-full h-[16px] mb-3"></div>
          </div>

          <hr class="my-12" />

          <!-- Related articles skeleton -->
          <div class="related-articles-skeleton">
            <div
              v-for="i in 4"
              :key="`related-article-${i}`"
              class="related-article-skeleton md:w-[calc(50%-1rem)] gap-[1rem] py-4 border-t last:border-b last:border-b-gray-600 border-t-gray-600"
            >
              <div class="flex gap-2">
                <div
                  class="loading-effect min-w-[160px] w-[160px] h-[128px] rounded-lg"
                ></div>
                <div class="flex flex-col flex-1">
                  <div class="loading-effect w-20 h-3 mb-2"></div>
                  <div class="loading-effect w-full h-4 mb-2"></div>
                  <div class="loading-effect w-3/4 h-3 mb-2"></div>
                  <div class="loading-effect w-24 h-3 mt-auto"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Sidebar column -->
      <div class="lg:col-span-1">
        <!-- Sidebar skeleton (desktop only) -->
        <div class="hidden lg:block sidebar-skeleton">
          <div class="loading-effect w-full h-[200px] rounded-lg mb-6"></div>
          <div class="loading-effect w-3/4 h-[24px] mb-3"></div>
          <div class="loading-effect w-full h-[16px] mb-2"></div>
          <div class="loading-effect w-5/6 h-[16px] mb-2"></div>
          <div class="loading-effect w-4/6 h-[16px] mb-4"></div>

          <div class="loading-effect w-full h-[120px] rounded-lg mb-4"></div>
          <div class="loading-effect w-2/3 h-[20px] mb-2"></div>
          <div class="loading-effect w-full h-[16px] mb-2"></div>
          <div class="loading-effect w-3/4 h-[16px]"></div>
        </div>
      </div>
    </div>

    <!-- Partner events skeleton -->
    <div class="mt-10">
      <div class="loading-effect w-1/3 h-[32px] mb-6"></div>
      <div class="flex flex-wrap gap-4">
        <div
          v-for="i in 3"
          :key="`partner-event-${i}`"
          class="loading-effect w-full md:w-[calc(33.333%-1rem)] h-[200px] rounded-lg"
        ></div>
      </div>
    </div>

    <!-- Related articles section skeleton -->
    <div class="mt-10">
      <div class="loading-effect w-1/2 h-[32px] mb-6"></div>
      <div class="flex flex-wrap gap-4">
        <div
          v-for="i in 3"
          :key="`related-section-${i}`"
          class="loading-effect w-full md:w-[calc(33.333%-1rem)] h-[250px] rounded-lg"
        ></div>
      </div>
    </div>
  </div>
</template>

<style lang="postcss" scoped>
@import '~/assets/css/loading.css';

.article-detail-skeleton {
  .title {
    @apply rounded;
  }

  .summary-block-skeleton {
    @apply text-[#1d1f22];
  }

  .related-article-skeleton {
    @apply flex flex-wrap justify-between;
  }

  .sidebar-skeleton {
    @apply sticky top-4;
  }
}
</style>
